import React from 'react';
import { Sparkles } from 'lucide-react';

import { buildCommittedProposal, getItemRoute } from './dashboardHelpers';

const WelcomeBanner = ({ userName, operational, planItems, todayStr, onDismiss, navigate }) => {
  const hour = new Date().getHours();
  const greeting = hour < 6 ? 'Hola' : hour < 13 ? 'Buenos días' : hour < 21 ? 'Buenas tardes' : 'Buenas noches';
  const firstName = (userName || 'usuario').split(' ')[0];
  const { committed, proposal } = buildCommittedProposal(todayStr, operational?.agenda, planItems || []);
  const overdue = committed.filter((c) => c.is_overdue);
  const parts = [];
  if (overdue.length > 0) parts.push(`${overdue.length} vencida${overdue.length !== 1 ? 's' : ''}`);
  const nonOverdueCommitted = committed.length - overdue.length;
  if (nonOverdueCommitted > 0) parts.push(`${nonOverdueCommitted} comprometid${nonOverdueCommitted !== 1 ? 'as' : 'a'}`);
  if (proposal.length > 0) parts.push(`${proposal.length} propuesta${proposal.length !== 1 ? 's' : ''}`);
  const summary = parts.length === 0 ? 'sin compromisos hoy' : `Tienes ${parts.join(', ').replace(/,([^,]*)$/, ' y$1')}.`;
  const firstItem = overdue[0] || committed[0] || proposal[0];
  const cta = firstItem ? { label: overdue.length > 0 ? 'Atender la primera vencida' : 'Empezar con el primer item', route: getItemRoute(firstItem) } : null;
  return (
    <div
      className="mx-4 mt-2 flex items-center justify-between gap-3 px-3 py-2 rounded-md bg-gradient-to-r from-primary/10 to-transparent border border-primary/20"
      data-testid="dashboard-welcome-banner"
    >
      <div className="flex items-center gap-2 text-sm min-w-0">
        <Sparkles className="w-4 h-4 text-primary flex-shrink-0" />
        <span>
          <strong className="font-semibold">{greeting}, {firstName}.</strong>{' '}
          <span className="text-muted-foreground">{summary}</span>
        </span>
      </div>
      <div className="flex items-center gap-2 flex-shrink-0">
        {cta && (
          <button
            type="button"
            onClick={() => navigate(cta.route)}
            className="text-xs font-medium text-primary hover:underline whitespace-nowrap"
            data-testid="welcome-cta-btn"
          >
            {cta.label} →
          </button>
        )}
        <button
          type="button"
          onClick={onDismiss}
          className="text-xs text-muted-foreground hover:text-foreground"
          aria-label="Cerrar bienvenida"
          data-testid="welcome-dismiss-btn"
        >
          ✕
        </button>
      </div>
    </div>
  );
};

export default WelcomeBanner;
